var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAzavinv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.051522, 254.309238)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 103.851562 -1.984375 L 53.578125 -131.304688 C 53.082031 -132.625 50.769531 -132.625 50.273438 -131.304688 L 0.164062 -1.984375 C -0.332031 -0.992188 0.332031 0 1.820312 0 L 24.476562 0 C 25.136719 0 25.964844 -0.332031 26.128906 -0.992188 L 51.925781 -74.746094 L 78.054688 -0.992188 C 78.21875 -0.332031 79.046875 0 79.542969 0 L 102.363281 0 C 103.519531 0 104.347656 -0.992188 103.851562 -1.984375 Z M 103.851562 -1.984375 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.79605, 254.309238)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 77.394531 -24.476562 L 9.425781 -24.476562 L 0.332031 -2.148438 C -0.164062 -0.828125 0.496094 0 2.148438 0 L 77.226562 0 C 78.386719 0 79.210938 -0.828125 79.210938 -1.488281 L 79.210938 -22.988281 C 79.210938 -23.8125 78.550781 -24.476562 77.394531 -24.476562 Z M 1.820312 -107.65625 L 42.664062 -107.65625 L 19.511719 -49.777344 L 46.632812 -49.777344 L 78.882812 -130.144531 C 79.210938 -131.46875 78.550781 -132.296875 77.0625 -132.296875 L 1.820312 -132.296875 C 0.828125 -132.296875 0 -131.46875 0 -130.808594 L 0 -109.308594 C 0 -108.484375 0.828125 -107.65625 1.820312 -107.65625 Z M 1.820312 -107.65625 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#00a3ff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.677152, 254.309238)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 103.851562 -1.984375 L 53.578125 -131.304688 C 53.082031 -132.625 50.769531 -132.625 50.273438 -131.304688 L 0.164062 -1.984375 C -0.332031 -0.992188 0.332031 0 1.820312 0 L 24.476562 0 C 25.136719 0 25.964844 -0.332031 26.128906 -0.992188 L 51.925781 -74.746094 L 78.054688 -0.992188 C 78.21875 -0.332031 79.046875 0 79.542969 0 L 102.363281 0 C 103.519531 0 104.347656 -0.992188 103.851562 -1.984375 Z M 103.851562 -1.984375 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#b500ff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(351.664594, 120.690505)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M -103.851562 1.984375 L -53.578125 131.304688 C -53.082031 132.625 -50.769531 132.625 -50.273438 131.304688 L -0.164062 1.984375 C 0.332031 0.992188 -0.332031 0 -1.820312 0 L -24.476562 0 C -25.136719 0 -25.964844 0.332031 -26.128906 0.992188 L -51.925781 74.746094 L -78.054688 0.992188 C -78.21875 0.332031 -79.046875 0 -79.542969 0 L -102.363281 0 C -103.519531 0 -104.347656 0.992188 -103.851562 1.984375 Z M -103.851562 1.984375 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAzavinv);
export default __webpack_public_path__ + "static/media/LOGO_AZAV (INV).366c9ce64f199f1d5c05150a08437466.svg";
export { ForwardRef as ReactComponent };